import { jsx } from "react/jsx-runtime";
import React__default, { useMemo } from "react";
import { ConciergeProductCard } from "./ConciergeProductCard.js";
import StoreCarousel from "./StoreCarousel.js";
import { ProductCardCarouselWidget } from "@brandclub/bc-widgets";
import { useProductClickTracking } from "./hooks/useProductClickTracking.js";
const ProductGroupCarousel = React__default.memo(({
  products,
  allStacklineSkus = [],
  isLoading = false
}) => {
  const { trackProductClick } = useProductClickTracking();
  const productMap = useMemo(() => {
    const map = /* @__PURE__ */ new Map();
    products.forEach((product) => {
      map.set(product.stacklineSku, product);
    });
    return map;
  }, [products]);
  const skusToRender = useMemo(
    () => allStacklineSkus.length > 0 ? allStacklineSkus : products.map((p) => p.stacklineSku),
    [allStacklineSkus, products]
  );
  if (isLoading && products.length === 0) {
    return /* @__PURE__ */ jsx("div", { className: "tw:w-full", children: /* @__PURE__ */ jsx(StoreCarousel, { children: [1, 2, 3, 4].map((i) => /* @__PURE__ */ jsx("div", { className: "tw:w-[240px] tw:h-[391.86px] tw:rounded-xl tw:bg-gray-200 tw:animate-pulse" }, i)) }) });
  }
  if ((!products || products.length === 0) && allStacklineSkus.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx(ProductCardCarouselWidget, { widgetId: "product-card-carousel", displayName: "Product Card Carousel", children: (cardStyles, carouselStyles, themeFonts, resolveColor) => {
    const itemWidth = carouselStyles.itemWidth;
    return /* @__PURE__ */ jsx("div", { className: "tw:w-full product-group-carousel", children: /* @__PURE__ */ jsx(StoreCarousel, { gap: carouselStyles.carouselGap, children: skusToRender.map((sku, index) => {
      const product = productMap.get(sku);
      if (product) {
        return /* @__PURE__ */ jsx("div", { style: { width: itemWidth, minWidth: itemWidth }, children: /* @__PURE__ */ jsx(
          ConciergeProductCard,
          {
            product,
            cardStyles,
            themeFonts,
            resolveColor,
            onProductClick: () => {
              trackProductClick({
                stacklineSku: product.stacklineSku,
                productTitle: product.title,
                clickSource: "carousel",
                productPosition: index,
                retailerId: product.retailerId,
                retailPrice: product.retailPrice,
                hasReward: product.hasRewards,
                rewardAmount: product.totalRewardAmount
              });
            }
          }
        ) }, sku);
      }
      return null;
    }) }) });
  } });
}, (prevProps, nextProps) => {
  const prevSkus = prevProps.allStacklineSkus || [];
  const nextSkus = nextProps.allStacklineSkus || [];
  if (prevSkus.length !== nextSkus.length) return false;
  if (prevProps.products.length !== nextProps.products.length) return false;
  if (prevProps.isLoading !== nextProps.isLoading) return false;
  for (let i = 0; i < prevSkus.length; i++) {
    if (prevSkus[i] !== nextSkus[i]) return false;
  }
  for (let i = 0; i < prevProps.products.length; i++) {
    if (prevProps.products[i].stacklineSku !== nextProps.products[i].stacklineSku) return false;
  }
  return true;
});
ProductGroupCarousel.displayName = "ProductGroupCarousel";
export {
  ProductGroupCarousel
};
//# sourceMappingURL=ProductGroupCarousel.js.map
